import { configureStore } from "@reduxjs/toolkit";
import appReducer from "redux/reducers/appSlice";
import userSettingReducer from "redux/reducers/userSettingSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    userSetting: userSettingReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
